// extracted by mini-css-extract-plugin
export var pillWrapper = "_ia-0";
export var showOverflow = "_ia-1";